import BreadCumb from "../Components/Common/BreadCumb";
import Terms from "../Components/Terms/Terms";

const TermsPage = () => {
    return (
        <div>
            <BreadCumb
                bgimg="/assets/images/bg/breadcumgBg.png"
                Title="Termos de Uso - FHC Traffic & Mídia"
            ></BreadCumb>
            <Terms></Terms>
        </div>
    );
};

export default TermsPage; 